export default __webpack_public_path__ + "static/media/tissue-rolling.390b7317.svg";